<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
    <PortalTarget name="popup" multiple></PortalTarget>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Главная',
    titleTemplate: 'География 6 класс',
  },
  computed: {
    layout() {
      return this.$route.meta.layout || 'default-layout'
    },
  },
}
</script>
<style lang="scss">
  @import './styles/main.scss';

  #app {
    background-image: linear-gradient(to bottom, transparent 95%, #D2F0FF 95%), linear-gradient(to right, transparent 95%, #D2F0FF 95%);
    background-size: 3rem 3rem, 3rem 3rem;
    padding: 2rem;
  }
</style>
